import { LocationData } from '@lts-web/data-objects';
import ObjectDataList from './ObjectDataList';

class LocationList extends ObjectDataList {
    constructor(type, locations) {
        super(type, locations);
    }

    add(location) {
        if (!(location instanceof LocationData))
            throw new TypeError('First argument must be and instanceof LocationData.');

        return this.getAll().push(location);
    }

    get(value) {
        const cityCode = this.getByCityCode(value);
        return cityCode ? cityCode : this.getByCityName(value);
    }

    getByCityCode(value) {
        return this.getByProperty('cityCode', value);
    }

    getByCityName(value) {
        return this.getByProperty('cityName', value);
    }

    getByProperty(property, value) {
        return this.find(location => location.getDataProperty(property) === value);
    }

    filterByProperty(property, value) {
        return this.filter(location => location.getDataProperty(property) === value);
    }

    findByProperty(property, value) {
        return this.find(location => ~location.getDataProperty(property).indexOf(value));
    }

    suggestByProperty(property, value) {
        return this.filter(location => ~location.getDataProperty(property).indexOf(value));
    }

    hasCountryLocation() {
        return this.some(location => location.getLocationType() === 'COUNTRY');
    }
}

LocationList.sorts = {
    byCountry(a, b) {
        if (a.getLocationType() !== 'COUNTRY' && b.getLocationType() === 'COUNTRY') {
            if(a.getCountryName() < b.getCityName())
                return -1;

            return 1;
        }

        if (a.getLocationType() === 'COUNTRY' && b.getLocationType() !== 'COUNTRY') {
            if(a.getCityName() > b.getCountryName())
                return 1;

            return -1;
        }

        if (a.getLocationType() === 'COUNTRY' && b.getLocationType() === 'COUNTRY') {
            if(a.getCityName() < b.getCityName())
                return -1;

            if(a.getCityName() > b.getCityName())
                return 1;

            return 0;
        }

        if (a.getCountryName() < b.getCountryName())
            return -1;

        if (a.getCountryName() > b.getCountryName())
            return 1;

        return 0;
    }
};

export default LocationList;